import React, { useContext, useMemo } from "react";

import {
  StartNodeUI,
  EndNodeUI,
  EmailNodeUI,
  SMSNodeUI,
  LetterNodeUI,
  CustomNodeUI,
} from "./CustomNodes";
import CampaignContext from "./CampaignContext";

const SideMenu: React.FC = () => {
  const { nodes } = useContext(CampaignContext);

  const buttonStatus = useMemo(() => {
    let status = 0;
    for (let i = 0; i < nodes.length; i++) {
      if (+nodes[i].data.type === 1) {
        status = 1;
      } else if (+nodes[i].data.type === 2) {
        return 2;
      }
    }

    return status;
  }, [nodes]); // if start node exists, it will be 1. if end node exists, it will be 2. otherwise it will be 0.

  return (
    <div className="side-menu d-flex flex-row flex-md-column justify-content-start justify-content-md-center align-items-center pb-2">
      {buttonStatus === 0 ? (
        <StartNodeUI className="mb-0 mb-md-2 me-2 me-md-0" />
      ) : buttonStatus === 1 ? (
        <EndNodeUI className="mb-0 mb-md-2 me-2 me-md-0" />
      ) : (
        ""
      )}
      <CustomNodeUI className="mb-0 mb-md-2 me-2 me-md-0" />
      <EmailNodeUI className="mb-0 mb-md-2 me-2 me-md-0" />
      <SMSNodeUI className="mb-0 mb-md-2 me-2 me-md-0" />
      <LetterNodeUI className="mb-0 mb-md-2 me-2 me-md-0" />
    </div>
  );
};

export default SideMenu;
